import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, InputLabel, Select, MenuItem,
  Typography, Box, TextField
} from '@mui/material';

const CopyDrillsModal = ({ open, onClose, currentDay, currentWeek, drillsToCopy, onConfirm, allDays, allWeeks }) => {
  const [targetDays, setTargetDays] = useState([]);
  const [targetWeeks, setTargetWeeks] = useState([]);
  const [appendMode, setAppendMode] = useState(true);

  useEffect(() => {
    setTargetDays([]);
    setTargetWeeks([]);
    setAppendMode(true);
  }, [open]);

  const handleSubmit = () => {
    if (targetDays.length === 0 || targetWeeks.length === 0) {
      alert("❌ Copy failed: Please select at least one target day and week");
      return;
    }

    const reorderedDrills = drillsToCopy.map((drill, index) => ({
      ...drill,
      id: undefined,
      drill_order: index + 1
    }));

    targetDays.forEach(day => {
      targetWeeks.forEach(week => {
        onConfirm(reorderedDrills, {
          targetDay: day,
          targetWeek: week,
          overwrite: !appendMode
        });
      });
    });

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Copy Drills From {currentDay} (Week {currentWeek})</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Target Day</InputLabel>
          <Select
            multiple
            value={targetDays}
            onChange={(e) => setTargetDays(e.target.value)}
            label="Target Day"
          >
            {allDays.filter(day => day !== currentDay).map(day => (
              <MenuItem key={day} value={day}>{day}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Target Week</InputLabel>
          <Select
            multiple
            value={targetWeeks}
            onChange={(e) => setTargetWeeks(e.target.value)}
            label="Target Week"
          >
            {allWeeks.map(week => (
              <MenuItem key={week} value={week}>Week {week}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Mode</InputLabel>
          <Select
            value={appendMode ? 'append' : 'overwrite'}
            onChange={(e) => setAppendMode(e.target.value === 'append')}
            label="Mode"
          >
            <MenuItem value="overwrite">Overwrite Existing Drills</MenuItem>
            <MenuItem value="append">Append to Existing Drills</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">Copy</Button>
      </DialogActions>
    </Dialog>
  );
};

const ReorderDrillsModal = ({ open, onClose, drills, onSave }) => {
  const [localDrills, setLocalDrills] = useState([]);

  useEffect(() => {
    setLocalDrills(drills.map(d => ({ ...d })));
  }, [drills]);

  const handleOrderChange = (index, value) => {
    const updated = [...localDrills];
    updated[index].drill_order = parseInt(value);
    setLocalDrills(updated);
  };

  const handleSave = () => {
    onSave(localDrills);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reorder Drills</DialogTitle>
      <DialogContent>
        {localDrills.map((drill, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography>{drill.drill_name}</Typography>
            <TextField
              label="Order"
              type="number"
              value={drill.drill_order || ''}
              onChange={(e) => handleOrderChange(index, e.target.value)}
              fullWidth
            />
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save Order</Button>
      </DialogActions>
    </Dialog>
  );
};

export { CopyDrillsModal, ReorderDrillsModal };
